import { setCookie } from '@/utils/index.js'
import { isiOS, isAndroid } from "@/utils/index";
import Bridge from './utils/bridge'
import store from './store'

export function getAppInfo(fuc = ()=>{}) {
  console.log('%c[getAppInfo] ===== getAppInfo 开始 =====', 'color:#e6a23c;font-weight:bold')
  console.log('[getAppInfo] fuc 类型:', typeof fuc)
  var called = false
  function safeCall() {
    if (called) return
    called = true
    fuc()
  }
  // 超时兜底：3秒后若 fuc 未调用，强制放行
  setTimeout(safeCall, 3000)
  let APPINFO = {
    xAppName: 'freshapp',
    xAcceptLanguage: 'en',
    xAppVersion: '1.0.0',
    xChannel: 'google_pay',
    platformCode: 'IOS'
  }
  console.log('[getAppInfo] 第1级 → Bridge("getHeaderInfo") 发起...')
  Bridge('getHeaderInfo',null,(res) => {
    console.log('[getAppInfo] 第1级 getHeaderInfo 回调触发! res:', res, '| 类型:', typeof res)
    try {
      if (!res) {
        console.log('[getAppInfo] res 为空 → 使用默认 APPINFO → safeCall()')
        store.dispatch('setAppInfo',APPINFO)
        safeCall()
        console.log('[getAppInfo] safeCall() 已调用 ✅ (第1级-空res)')
        return
      }
      console.log('[getAppInfo] res 有值 → JSON.parse 中...')
      APPINFO = JSON.parse(res)
      console.log('[getAppInfo] JSON.parse 成功 → APPINFO:', APPINFO)
      store.dispatch('setAppInfo',APPINFO)
      console.log('[getAppInfo] 第2级 → Bridge("getTokenInfo") 发起...')
      Bridge('getTokenInfo',null,(token) => {
        console.log('[getAppInfo] 第2级 getTokenInfo 回调触发! token:', token, '| 类型:', typeof token)
          if (!token) {
              console.log('[getAppInfo] token 为空 → safeCall()')
              safeCall()
              console.log('[getAppInfo] safeCall() 已调用 ✅ (第2级-空token)')
              return
          }
          setCookie('token',token)
          console.log('[getAppInfo] token 已存 cookie → 第3级 Bridge("getTaskbarHeight") 发起...')
          Bridge('getTaskbarHeight',null,(height) => {
            console.log('[getAppInfo] 第3级 getTaskbarHeight 回调触发! height:', height, '| 类型:', typeof height)
              if (!height) {
                  console.log('[getAppInfo] height 为空 → safeCall()')
                  safeCall()
                  console.log('[getAppInfo] safeCall() 已调用 ✅ (第3级-空height)')
                  return
              }
              let areaHeight = (height * 100).toFixed(2)
              console.log('[getAppInfo] areaHeight = height*100 =', areaHeight)
              localStorage.setItem('taskbarHeight',areaHeight)
              console.log('[getAppInfo] taskbarHeight 已存 localStorage → safeCall()')
              safeCall()
              console.log('[getAppInfo] safeCall() 已调用 ✅ (第3级-正常完成)')
          })
      })
    } catch (error) {
      console.error('%c[getAppInfo] ❌ catch 异常!', 'color:red;font-weight:bold', error)
      store.dispatch('setAppInfo',APPINFO)
      safeCall()
      console.log('[getAppInfo] safeCall() 已调用 ✅ (catch异常兜底)')
    }
  })
}



// WEBPACK FOOTER //
// ./src/settings.js